module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/sp/common/btn_consult-be866f2e5c3fbe45bebaf1b7df7867a1.png";